@if ((control.dirty || control.touched) && control.invalid && control.errors) {
  <div class="pt-1 pb-2">
    <span class="text-danger caption">
      {{ this.translations + '.' + Object.keys(control.errors)[0] | translate }}
    </span>
  </div>
}
